import axios from '../../../commons/gdprcontrol-axios'

function getEventTemplateSkeleton () {
  return {
    id: null,
    subject: '',
    description: '',
    partner: null,
    category: null
  }
}

const state = {
  eventTemplate: getEventTemplateSkeleton()
}

const getters = {
  getEventTemplate: state => state.eventTemplate
}

const actions = {
  fetchEventTemplate: async ({ commit }, eventTemplateId) => {
    return axios.get(`/api/event-templates/${eventTemplateId}/`)
      .then(response => {
        commit('setEventTemplate', response.data)
      })
  },

  saveNewEventTemplate: async ({ commit, state }) => {
    return axios.post('/api/event-templates/', state.eventTemplate)
      .then(response => {
        commit('setEventTemplate', response.data)
      })
  },

  updateEventTemplate: async ({ commit, state }) => {
    return axios.put(`/api/event-templates/${state.eventTemplate.id}/`, state.eventTemplate)
      .then(response => {
        commit('setEventTemplate', response.data)
      })
  }
}

const mutations = {
  setEventTemplate (state, eventTemplate) {
    state.eventTemplate = eventTemplate
  },

  setAttribute (state, { name, value }) {
    state.eventTemplate[name] = value
  },

  resetEventTemplate (state) {
    state.eventTemplate = getEventTemplateSkeleton()
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/eventTemplates/details.js